<template>
    <div class="container-fluid">
        <div class="col-xl-12">
            <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
                <h2 style="flex: 1;">Reports</h2>
            </div>
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 container">
            <div class="main-container">
                <div class="row">
                    <div class="col-sm-2 this-sidebar">
                        <SelectReportComponent
                            @updateSelectedReport="updateSelectedReport"
                            title="Select Report"
                            :reports="reports"
                            :options="fetchData.titles"
                        >
                        </SelectReportComponent>

                        <span v-if="hasIncludes()">
                            <p class="title" style="margin:10px 0">Includes</p>
                            <CheckboxComponent
                                @checkboxSelected="_checkboxSelected"
                                v-for="item in returnIncludes()"
                                :key="item.id"
                                :title="item"
                            />
                        </span>

                        <div v-if="hasFilters()">
                            <p class="title" style="margin:10px 0">Filters</p>
                            <div
                                v-for="item in returnFilters()"
                                :key="item.id"
                                class="filter-field"
                            >
                                <FilterInputComponent
                                    @updateInputFilter="_updateInputFilter"
                                    v-if="item.type == 'text' || item.type == 'freetext'"
                                    :placeholder="removeDollarSign(item.key)"
                                />

                                <FilterSelectComponent
                                    @setFilterSelect="_setFilterSelect"
                                    v-if="item.type == 'radio'"
                                    :placeholder="removeDollarSign(item.key)"
                                    :options="item.options"
                                />
                            </div>
                        </div>

                        <div class="buttonSection">
                            <button @click="fetchReport" class="btn btn-primary">Fetch Report</button>
                        </div>
                    </div>
                    <div class="col-sm-10">
                        <LoadingComponent v-if="loading" />
                        <EmptyViewComponent v-if="output.length < 1 && !loading" />
                        <div v-if="output.length > 0 && !loading">
                            <div class="header-bar">
                                <h4 class="title">{{fetchData.data.title}} Reports</h4>
                                <button @click="downloadReport" class="btn btn-primary yellow-btn">Download CSV</button>
                            </div>
                            <!-- <div
                                class="table"
                                v-for="data in output"
                                :key="data.id"
                                v-html="displayValue(data)"
                            ></div> -->

                            <vue-good-table
                                :columns="tableColumns(output)"
                                :rows="output"
                                :pagination-options="{enabled: true}"
                            >

                                <template v-if="isObjectType(props.column.field)" slot="table-row" slot-scope="props" style="background: red;">
                                    <ShowIncludesContent :row="props.row" :field="props.column.field" />
                                </template>

                                <template slot="pagination-bottom" slot-scope="props">
                                    <grey-pagination
                                        :total="props.total"
                                        :pageChanged="props.pageChanged"
                                        :perPageChanged="props.perPageChanged"
                                    ></grey-pagination>
                                </template>

                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Notification
} from "element-ui";

import {
    LoadingComponent,
    CheckboxComponent,
    EmptyViewComponent,
    ShowIncludesContent,
    FilterInputComponent,
    SelectReportComponent,
    FilterSelectComponent,
} from "../kitchen/ArnergyReportComponents/index";

export default {
    name: "",

    data() {
        return {
            reports: [],
            fetchData: {
                data: {
                    config: {
                        include: "",
                        parameters: [{
                            key: "",
                            options: "",
                            type: ""
                        }],
                        where: ""
                    },
                    endpoint: "",
                    id: 0,
                    title: ""
                }, // this will be removed...
                includes: [],
                endpoints: "",
                titles: []
            },
            postData: {
                endpoint: "",
                includes: [],
                filter: []
            },
            output: [],
            loading: false,
            tableOptions: [],
            outputList: []
        };
    },

    components: {
        LoadingComponent,
        CheckboxComponent,
        EmptyViewComponent,
        ShowIncludesContent,
        FilterInputComponent,
        SelectReportComponent,
        FilterSelectComponent,
    },

    computed: {
    },

    watch: {
    },

    methods: {
        getReports() {
            const HTTP = this.$httpUtils.instance;
            const container = this;
            HTTP.get("/reporting").then(reports => {
                container.reportData = reports.data;
                this.reports = container.reportData

                // fetch all titles
                this.fetchAllTitles();
            });
        },

        showAlarm() {
            Notification.error({
                title: 'Error',
                dangerouslyUseHTMLString: true,
                message: 'Kindly select a report to filter.'
            });
        },

        fetchAllTitles(){
            this.reports.forEach(item=>{
                this.fetchData.titles.push(item.title)
            })
        },

        /**
         * Emitted methods
         */
        updateSelectedReport(selectedTitle, selectedEndpoint){
            this.output = [];
            this.postData.includes = [];
            this.postData.filter = [];

            this.reports.forEach(item=>{
                if(item.title == selectedTitle && item.endpoint == selectedEndpoint){
                    this.fetchData.data = item //update fetch data data
                    this.postData.endpoint = selectedEndpoint // update postData endpoint value
                }
            })
        },

        fetchReport(){
            if(this.postData.endpoint == ''){
                // show error notification
                this.showAlarm()
                return;
            }

            this.loading = true; //enable loading

            // prepare request
            const HTTP = this.$httpUtils.instance;
            let endpoint = this.postData.endpoint;
            endpoint += "?";

            // includes
            if(this.postData.includes.length > 0){
                this.postData.includes.forEach(item=>{
                    endpoint += `filter[include]=${item.value}&`;
                })
            }

            // console.log('includes', this.postData.includes)

            // filters
            if(this.postData.filter.length > 0){
                this.postData.filter.forEach(item=>{
                    if(item.value != ''){
                        endpoint += `filter[where][${item.field}]=${item.value}&`
                    }
                })
            }

            // send data
            // console.log(endpoint)
            const container = this;
            HTTP.get(endpoint).then(reports => {
                // console.log(reports.data)
                this.output = reports.data
                this.loading = false; // disable loading
            });

        },

        /**
         * handle $children events
         */
        _checkboxSelected(input, status){
            const {includes} = this.postData;

            const title = JSON.parse(input)
            if(status){
                includes.push(title)
            }else{
                includes.forEach(item=>{
                    if(item.value == title.value){
                        const value = includes.indexOf(item)
                        includes.splice(value, 1)
                    }
                })
            }
        },

        _updateInputFilter(val){
            this.updateFiltersItem(val)
        },

        _setFilterSelect(val){
            this.updateFiltersItem(val)
        },

        /**
         * Misc methods
         */
        hasIncludes(){
            // is this not too long bayii?
            if(JSON.parse(this.fetchData.data.config.include.length) > 0){
                return true
            }
            return false
        },

        hasFilters(){
            if(JSON.parse(this.fetchData.data.config.parameters.length) > 1){
                return true
            }
            return false
        },

        returnIncludes(){
            return JSON.parse(this.fetchData.data.config.include)
        },

        returnFilters(){
            return this.fetchData.data.config.parameters
        },

        removeDollarSign(val){
            try{
                const firstLetter = val.charAt(0)
                if(firstLetter == "$"){
                    return val.substring(1)
                }
            }catch(error){
                console.log(error)
            }
            return val;
        },

        updateFiltersItem(input){
            const userInput = JSON.parse(input)
            const {filter} = this.postData

            filter.forEach(item => {
                if((item.field == userInput.field)){
                    const value = filter.indexOf(item)
                    filter.splice(value, 1)
                }
            })
            filter.push(userInput)
        },

        tableColumns(data){
            const finalOutput = [];
            // const output = Object.keys(data[0]);
            Object.keys(data[0]).forEach(item => {
                finalOutput.push({
                    label: item,
                    field: item,
                })
            })
            return finalOutput;
        },

        // tableRows(data){
        //     const finalOutput = [];
        //     data.forEach(item => {
        //         finalOutput.push(Object.values(item))
        //     })
        //     console.log('final output', data)
        //     return finalOutput;
        // },

        isObjectType(value){

            const includedValues = this.postData.includes;

            if(includedValues.length > 0){
                for(let i=0; i<includedValues.length; i++){
                    if(includedValues[i].value == value){
                        // return includedValues[i].value;
                        return true;
                    }
                }
            }

            // includedValues.forEach(item => {
            //     if(item.value == value){
            //         output = true;
            //         // return true;
            //     }
            // })

            return false
        },

        displayValue(data){
            let htmlData = "";
            if(typeof data == 'object'){
                try{
                    const obj = Object.entries(data)
                    // const titles = Object.keys(data);
                    // const titles = data;
                    // console.log('the titles: ', titles)
                    obj.forEach(item=>{
                        if(typeof item[1] == 'object' && item[1] != null){
                            htmlData += `
                                <div class="container">
                                    <div class="row" style="padding:4px">
                                        <div class="col-xs-12"><strong>${item[0]}</strong></div>
                                        <div class="col-xs-12">${this.displayObjChild(item[1])}</div>
                                    </div>
                                </div>
                            `;
                        }else{
                            htmlData += `
                                <div class="container">
                                    <div class="row" style="padding:4px">
                                        <div class="col-xs-3">${item[0]}:</div>
                                        <div class="col-xs-9">${item[1]}</div>
                                    </div>
                                </div>
                            `;
                        }
                    })
                }catch(error){
                    console.log(error)
                }
            }

            return htmlData
        },

        displayObjChild(val){
            let htmlData = "";
            const obj = Object.entries(val)
            obj.forEach(item=>{
                htmlData += `
                    <div class="container">
                        <div class="row" style="padding:4px">
                            <div class="col-xs-3">${item[0]}:</div>
                            <div class="col-xs-9">${item[1]}</div>
                        </div>
                    </div>
                `;
            })
            return htmlData;
        },

        downloadReport(){
            // let csv = 'Name,Title\n';
            let csv = this._getFieldTitles(this.output);
            const data = this._getFieldValues(this.output);

            // console.log(csvData);
            // return;

            // const data = [
            //     ['Foo', 'programmer'],
            //     ['Bar', 'bus driver'],
            //     ['Moo', 'Reindeer Hunter']
            // ];

            data.forEach(function(row) {
                csv += row.join(',');
                csv += "\n";
            });

            // console.log(csv);
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'reports.csv';
            hiddenElement.click();
        },

        _getFieldTitles(array){
            return Object.keys(array[0]).toString() + '\n';
        },

        _getFieldValues(array){
            const output = [];
            array.forEach(item=>{
                output.push(Object.values(item));
            })
            return output;
        }
    },

    async mounted() {
        this.getReports();
    }
};
</script>

<style lang="scss" scoped>
    .this-sidebar {
        border-right: 1px solid lighten(#333, 70%);
    }

    .legend{
        font-size: 16px;
    }

    .col-form-legend{
        padding: 0;
    }

    .label-title{
        font-size: 15px;
    }

    .title-name{
        color: #1a93ca;
    }

    .this-text{
        font-size: 12px;
    }

    .buttonSection{
        margin-top: 20px;
    }

    .filter-field{
        &+.filter-field{
            margin-top: 10px;
        }
    }

    .table{
        background-color: white;
        padding: 20px;

        &:nth-child(odd){
            background-color: #fdfbfb;
        }
    }

    .header-bar{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .yellow-btn{
        background-color: #ffb946;
        border-color: #ffb946;

        &:hover{
            background-color: darken(#ffb946, 10%);
        border-color: darken(#ffb946, 10%);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/reports/index.vue